module.exports = __webpack_public_path__ + "svg/stomach-average.b416b14d5052183b49751572a9d72822.svg";